import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  flex: 1;
  background: #ffffff;
  width: 100%;
  max-width: 464px;
  border-radius: 2px;
  padding: 24px 48px;
  box-shadow: 2px 2px 8px -4px rgba(0, 0, 0, 0.1);

  @media (max-width: 1400px) {
    max-width: 100%;
  }
`;
export const Title = styled.h1`
  color: #98a9bc;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 24px;
`;
export const SubTitle = styled.p`
  width: ${({
  width
}) => width ?? '100%'};
  color: #778ca2;
  font-size: 14px;
  font-weight: bold;
  margin: ${({
  margin
}) => margin ?? '12px 0 20px 0'};

  &:after {
    content: '';
    display: block;
    height: 1px;
    background-color: #e8ecef;
  }
`;
export const MembersContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 550px;
  overflow: auto;
  gap: 28px;
`;
export const AddMember = styled.div`
  display: flex;
  width: 100%;
  margin: 20px 0;

  button {
    cursor: pointer;
    border: 0;
    background-color: #ffffff;
    font-weight: 500;
    color: #4d7cfe;
  }
`;